module.exports = __webpack_public_path__ + "assets_1777427128813/img/guide_ios.431fc979.png";